import { POPUP_STYLE, ARROW_STYLE } from './markerConstants';

let activeRemovePopup = null;

export function createMarkerPopup(marker, map, anchorY, buildContent, onPopupOpen) {
  let popupElement = null;
  let hideTimer = null;
  let showTimer = null;

  const scheduleRemove = () => {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => {
      if (popupElement) {
        if (popupElement._cleanup) popupElement._cleanup();
        popupElement = null;
      }
    }, 100);
  };

  const cancelRemove = () => {
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
  };

  const removePopup = () => {
    clearTimeout(showTimer);
    cancelRemove();
    if (popupElement) {
      if (popupElement._cleanup) popupElement._cleanup();
      popupElement = null;
    }
  };

  const showPopup = () => {
    if (popupElement) return;
    const markerData = marker.getData();
    const markerPosition = marker.getGeometry();

    // Wrapper sits outside scroll so arrow isn't clipped
    const wrapper = document.createElement('div');
    wrapper.style.position = 'absolute';
    wrapper.style.zIndex = '10000';
    wrapper.style.pointerEvents = 'auto';

    popupElement = document.createElement('div');
    Object.assign(popupElement.style, POPUP_STYLE);
    popupElement.style.position = 'relative';
    popupElement.style.transform = 'none';
    popupElement.style.marginBottom = '0';

    const arrow = document.createElement('div');
    Object.assign(arrow.style, ARROW_STYLE);

    popupElement.innerHTML = buildContent(markerData);
    wrapper.appendChild(popupElement);
    wrapper.appendChild(arrow);

    if (onPopupOpen) onPopupOpen(popupElement, markerData);

    document.body.appendChild(wrapper);
    wrapper.style.position = 'fixed';

    const popupHeight = popupElement.offsetHeight; // read once, not on every frame
    let rafId = null;

    const updatePopupPosition = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        const resolvedAnchorY = typeof anchorY === 'function' ? anchorY(markerData) : anchorY;
        const screenPos = map.geoToScreen(markerPosition);
        const mapRect = map.getElement().getBoundingClientRect();
        wrapper.style.left = `${mapRect.left + screenPos.x}px`;
        wrapper.style.top = `${mapRect.top + screenPos.y - resolvedAnchorY - popupHeight - 8}px`;
        wrapper.style.transform = 'translateX(-50%)';
      });
    };

    updatePopupPosition();

    map.addEventListener('mapviewchange', updatePopupPosition);
    popupElement._cleanup = () => {
      map.removeEventListener('mapviewchange', updatePopupPosition);
      if (rafId) cancelAnimationFrame(rafId);
      wrapper.remove();
    };
    popupElement.remove = () => {}; // removal handled by wrapper
    popupElement._wrapper = wrapper;

    wrapper.addEventListener('mouseenter', cancelRemove);
    wrapper.addEventListener('mouseleave', scheduleRemove);
  };

  marker.addEventListener('pointerenter', () => {
    cancelRemove();
    clearTimeout(showTimer);
    if (activeRemovePopup && activeRemovePopup !== removePopup) {
      activeRemovePopup();
    }
    activeRemovePopup = removePopup;
    showTimer = setTimeout(showPopup, 100);
  });

  marker.addEventListener('pointerleave', () => {
    clearTimeout(showTimer);
    scheduleRemove();
  });
  marker._removePopup = removePopup;
}
